export default {
  data() {
    const level = [
      {
        value: 1,
        label: 'AAA',
      },
      {
        value: 2,
        label: 'AA+',
      },
      {
        value: 3,
        label: 'AA',
      },
      {
        value: 4,
        label: 'AA-',
      },
      {
        value: 5,
        label: 'A+',
      },
      {
        value: 6,
        label: 'A',
      },
      {
        value: 7,
        label: 'A-',
      },
      {
        value: 8,
        label: 'BBB',
      },
      {
        value: 9,
        label: 'BB',
      },
      {
        value: 10,
        label: 'B',
      },
    ] //客户级别
    return {
      //企业基本信息
      BASIC_INFO_SCHEMA: {
        name: {
          label: '企业名称',
          type: 'input',
          rules: [{ required: true, message: '请输入企业名称' }],
        },
        code: {
          label: '客户编码',
          type: 'input',
          rules: [{ required: true, message: '请输入客户编码' }],
        },
        geo: {
          label: 'Geo',
          type: 'input',
        },
        registeredNo: {
          label: '社会信用代码',
          type: 'input',
        },
        address: {
          label: '公司地址',
          type: 'input',
        },
        customerType: {
          label: '客户类型',
          type: 'input',
        },
        commerce: {
          label: '商务名称',
          type: 'input',
        },
        // business: {
        //   label: '业务类型',
        //   type: 'select',
        //   optionList: [],
        //   rules: [{ required: true, message: '请选择业务类型' }],
        //   allowClear: true,
        //   emit: 'handleBusiTypeChange', // 当为联动select时，监听select的change事件，并调用该方法
        // },
        business: {
          label: '业务类型',
          type: 'select',
          rules: [{ required: true, message: '请选择业务类型' }],
          allowClear: true,
          slotName: 'business', // 具名插槽
          // emit: 'handleBusiTypeChange', // 当为联动select时，监听select的change事件，并调用该方法
        },
        region: {
          label: '大区',
          type: 'select',
          allowClear: true,
          slotName: 'region', // 具名插槽
        },
        model: {
          label: '业务模式',
          type: 'select',
          rules: [{ required: true, message: '请选择业务模式' }],
          allowClear: true,
          slotName: 'model', // 具名插槽
        },
        signDate: {
          label: '联想签约日期',
          type: 'datePicker', // datePicker类型
          dateFormat: 'YYYY-MM-DD',
          rules: [{ required: true, message: '请选择联想签约日期' }], // 校验
        },
        registerDate: {
          label: '公司注册日期',
          type: 'datePicker', // datePicker类型
          dateFormat: 'YYYY-MM-DD',
          rules: [{ required: true, message: '请选择公司注册日期' }], // 校验
        },
        defaultScoreType: {
          label: '默认评分卡',
          type: 'select',
          rules: [{ required: true, message: '请选择默认评分卡' }], // 校验
          optionList: [],
        },
        creditManager: {
          label: '信用主管',
          type: 'select',
          rules: [{ required: true, message: '请选择信用主管' }],
          optionList: [],
        },
        businessSupervisor: {
          label: '商务主管',
          type: 'select',
          optionList: [],
        },
        receivableParty: {
          label: '应收人员',
          type: 'input',
          maxLength: 200,
        },
        currency: {
          label: '货币',
          type: 'input',
          rules: [{ required: true, message: '请输入货币' }],
        },
        stdAccountPeriod: {
          label: '标准账期',
          handleInputCheck: 'checkPositiveInt',
          type: 'input',
          rules: [{ required: true, message: '请输入标准账期' }],
        },
        national: {
          label: '国家',
          type: 'select',
          rules: [{ required: true, message: '请选择国家' }], // 校验
          optionList: [],
        },
        vendor: {
          label: 'Vendor',
          type: 'input',
          maxLength: 10,
        },
      },
      //企业额外信息
      EXTRA_INFO_SCHEMA: {
        legalPerson: {
          label: '企业法人',
          type: 'input',
        },
        legalPersonCard: {
          label: '法人身份证信息',
          type: 'input',
        },
        shareholder: {
          label: '企业股东',
          type: 'input',
        },
        shareholderCard: {
          label: '股东身份证信息',
          type: 'input',
        },
        registerMoney: {
          label: '注册资本(元)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        shareholderNature: {
          label: '股东性质',
          type: 'select',
          optionList: [
            {
              value: 1,
              label: '上市公司',
            },
            {
              value: 2,
              label: '央企、国企',
            },
            {
              value: 3,
              label: '股份有限公司',
            },
            {
              value: 4,
              label: '有限责任公司',
            },
            {
              value: 5,
              label: '其他（私人等）',
            },
          ],
        },
        registerCode: {
          label: '客户注册号',
          type: 'input',
        },
        lastRefundAvgDays: {
          label: '上财年加权平均回款天数',
          type: 'input',
          handleInputCheck: 'checkPositiveInt',
        },
        lastExpiryTimes: {
          label: '上财年逾期次数',
          type: 'input',
          handleInputCheck: 'checkPositiveInt',
        },
        lastExpiryRate: {
          label: '上财年3天以上逾期率(%)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        expiryAvgDays: {
          label: '近三财年加权平均逾期天数',
          type: 'input',
          handleInputCheck: 'checkPositiveInt',
        },
        expiryAvgRate: {
          label: '近三财年3天以上逾期率(%)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        isExpiryRisk: {
          label: '上财年是否出现真实逾期风险',
          type: 'select',
          optionList: [
            {
              label: '否',
              value: '2',
            },
            {
              label: '是',
              value: '1',
            },
          ],
        },
        isExpiry: {
          label: '目前是否存在真实逾期',
          type: 'select',
          optionList: [
            {
              label: '否',
              value: '2',
            },
            {
              label: '是',
              value: '1',
            },
            {
              label: '新客户',
              value: '3',
            },
          ],
        },
        purchasePlan: {
          label: '未来一年联想直接采购预估额(元)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        purchase: {
          label: '近三年进货额(元)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        purchaseRateIncrement: {
          label: '联想直接采购额年增长率(%)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        level: {
          label: '客户级别',
          type: 'select',
          optionList: level,
        },
        industryLevel: {
          label: '行业风险级别',
          type: 'select',
          optionList: [
            {
              label: '绿色',
              value: 1,
            },
            {
              label: '黄色',
              value: 2,
            },
            {
              label: '红色',
              value: 3,
            },
          ],
        },
        regionLevel: {
          label: '地域风险级别',
          type: 'select',
          optionList: [
            {
              label: '绿色',
              value: 1,
            },
            {
              label: '黄色',
              value: 2,
            },
            {
              label: '红色',
              value: 3,
            },
          ],
        },
        establishYear: {
          label: '成立年限',
          type: 'input',
        },
        coopTime: {
          label: '合作年限',
          type: 'select',
          optionList: [],
        },
        actualReceipt: {
          label: '实收资本(元)',
          type: 'input',
          handleInputCheck: 'checkFloat2',
        },
        subjectiveEvaluation: {
          label: '主观评价',
          type: 'input',
          placeholder: '请输入数字',
          rules: [{ required: true, message: '请选择主观评价' }],
          handleInputCheck: 'checkFloat2',
        },
      },
      labelCol: {
        xs: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 16 },
      },
      //企业基本信息-数据
      sourceDataBasic: {
        id: '',
        name: '',
        code: '',
        geo: '',
        address: '',
        registeredNo: '',
        customerType: '',
        commerce: '',
        national: '',
        business: '',
        region: '',
        model: '',
        signDate: '',
        registerDate: '',
        defaultScoreType: '',
        creditManager: '',
        businessSupervisor: '',
        receivableParty: '',
        currency: '',
        vendor: '',
        stdAccountPeriod: '',
      },
      //企业额外信息-数据
      sourceDataExtra: {
        id: '',
        companyCode: '',
        industryGroup: '',
        legalPerson: '',
        legalPersonCard: '',
        shareholder: '',
        shareholderCard: '',
        registerMoney: '',
        shareholderNature: '',
        registerCode: '',
        lastRefundAvgDays: '',
        lastExpiryTimes: '',
        lastExpiryRate: '',
        expiryAvgDays: '',
        expiryAvgRate: '',
        isExpiryRisk: '',
        isExpiry: '',
        purchasePlan: '',
        purchase: '',
        purchaseRateIncrement: '',
        level: '',
        industryLevel: '',
        regionLevel: '',
        establishYear: '',
        coopTime: '',
        actualReceipt: '',
        subjectiveEvaluation: '',
      },
      formLayout: 'horizontal',
      labelColExtra: {
        xs: { span: 12 },
      },
      wrapperColExtra: {
        xs: { span: 12 },
      },
      defaultColXs: 24,
      defaultColSm: 24,
      defaultColMd: 24,
      defaultColLg: 24,
      defaultColXl: 12,
    }
  },
}
